import { useState } from "react";
import { DateTimePicker } from "@/components/common";

export default function DateTimePickerTestPage() {
  const [selectedDateTime, setSelectedDateTime] = useState<Date | undefined>(
    undefined
  );
  const [selectedDateTime12h, setSelectedDateTime12h] = useState<
    Date | undefined
  >(undefined);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-8 p-8">
      <h1 className="text-2xl font-bold">DateTimePicker Component Test</h1>

      <div className="flex gap-8">
        <div className="flex flex-col items-center gap-4">
          <h2 className="text-lg font-semibold">24-Hour Mode</h2>
          <div className="flex flex-col items-center gap-2">
            <label className="text-sm font-medium">Selected Value:</label>
            <pre className="rounded-md bg-muted p-4 text-sm">
              {selectedDateTime
                ? selectedDateTime.toISOString()
                : "No date selected"}
            </pre>
          </div>
          <DateTimePicker
            value={selectedDateTime}
            onChange={setSelectedDateTime}
            placeholder="Select date and time"
            hourMode={24}
          />
        </div>

        {/* <div className="flex flex-col items-center gap-4">
          <h2 className="text-lg font-semibold">12-Hour Mode</h2>
          <div className="flex flex-col items-center gap-2">
            <label className="text-sm font-medium">Selected Value:</label>
            <pre className="rounded-md bg-muted p-4 text-sm">
              {selectedDateTime12h
                ? selectedDateTime12h.toISOString()
                : "No date selected"}
            </pre>
          </div>
          <DateTimePicker
            value={selectedDateTime12h}
            onChange={setSelectedDateTime12h}
            placeholder="Select date and time"
            hourMode={12}
          />
        </div> */}
      </div>
    </div>
  );
}